import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {iFrameState} from "../../../../services/IFrameState";
import {GATE_TYPE} from "../../../../../blink-sdk/Constants";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {NewsletterFlowController} from "../../../flows/NewsletterFlowController";
import {BasePanel, BasePanelStyle} from "../BasePanel";
import {MerchantAudienceMemberStore} from "../../../../../client/state/merchant/MerchantAudienceMemberStore";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {INLINE_NEWSLETTER_URLS} from "../../../PaywallConstants";
import {Router} from "../../../../../stem-core/src/ui/Router";


export class NewsletterPanelStyle extends BasePanelStyle {
    @styleRuleInherit
    paywallPage = {
        display: "flex",
        alignItems: "center",
        flexDirection: () => iFrameState.gateType === GATE_TYPE.banner ? "row" : "column",
    };
}

@registerStyle(NewsletterPanelStyle)
export class NewsletterPanel extends BasePanel {
    getControllerClass() {
        return NewsletterFlowController;
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(MerchantAudienceMemberStore, () => {
            if (iFrameUserDataService.isUserSubscribedToAllGivenNewsletters()) {
                Router.changeURL(INLINE_NEWSLETTER_URLS.success);
            }
        });
    }
}
